<script setup>
    import { defineProps } from 'vue'
    import { useRoute } from 'vue-router'
    import { Icon } from '@iconify/vue'
    import { useChatStore } from '@/stores/chat'
    const store = useChatStore()

    const props = defineProps({
        icon: { type: String, required: true },
        badge: { type: Boolean },
        name: { type: String, required: true },
        class: { type: String, default: '' },
        classIcon: { type: String, default: '' },
        to: { type: Object, default: () => ({}) },
        useActive: { type: Boolean, default: true },
        phone: { type: Boolean, default: false },
        animateicon: { type: Boolean, default: false }
    })

    const active = () => {
        if (!props.useActive) return false
        if(!useRoute().name) return false
        const splitRouteName = useRoute().name.split('.')
        const joinTwoFirst = splitRouteName.slice(0, 2).join('.')

        return props.to.name.includes(useRoute().name) || props.to.name.includes(joinTwoFirst)
    }
</script>

<template>
    <RouterLink
        :to="props.to"
        active-class="menu-item-active"
        :class="[
            { 'bg-slate-200' : phone},
            'text-chat-gray dark:text-gray-400 flex flex-col items-center p-2 rounded-lg chat_transition',
            'hover:text-chat-primary outline-none focus:ring-2 focus:ring-chat-primary',
            'dark:hover:text-white dark:focus:ring-neutral-600 dark:focus:text-white menu-item',
            props.class
        ]"
    >
        <div class="flex justify-center relative inline-flex">
            
            <span v-if="badge" class="absolute flex h-3 w-3 -top-2 -end-2">
                <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
                <span class="relative inline-flex rounded-full h-3 w-3 bg-red-500"></span>
            </span>  
            <span v-if="store().newMessagesCount > 0 && props.to.name == 'chat.attendances.progress'" class="absolute flex h-4 min-w-4 -top-2 -end-2">
                <span class="relative inline-flex rounded-full h-4 min-w-4 bg-red-500 text-xs items-center justify-center text-white">
                    {{ store().newMessagesCount }}
                </span>
                
            </span>
            <Unicon v-if="false"
                :name="props.icon"
                :class="[
                    'shadow-lg outline-none shadow-transparent h-9 w-9 p-2 rounded-lg',
                    {'chat_shadow text-chat-primary dark:text-white dark:bg-chat-primary': active()},
                    'chat_transition dark:focus:ring-white dark:focus:text-chat-primary',
                    props.classIcon
                ]"
                aria-hidden="true"
            />
 
            <Icon 
                :icon="props.icon"
                :class="[
                    'shadow-lg outline-none shadow-transparent h-9 w-9 p-2 rounded-lg',
                    {'chat_shadow text-chat-primary dark:text-white dark:bg-chat-primary': active()},
                    'chat_transition dark:focus:ring-white dark:focus:text-chat-primary',
                    props.classIcon,
                    [{ 'animate-bounce text-red-600' : props.animateicon }]
                    
                ]"
            />
        </div>

        <div
            class="w-[65px] break-word text-xs text-center  group-hover:opacity-100"
            :class="[{ 'mt-2' : active() }]"
        >
            <span>{{ props.name }}</span>
        </div>

        
    </RouterLink>
</template>
